import { ActiveFiltersMap, Filter, FilterType } from '@wwt/entities/filters'

export const generageActiveFiltersMapFromFilters = (
	filters: Filter[],
	activeFiltersMap?: ActiveFiltersMap
) => {
	const newFilters: ActiveFiltersMap = activeFiltersMap
		? // TODO: Remove structuredClone
			// eslint-disable-next-line
			structuredClone(activeFiltersMap)
		: {}

	filters.forEach(filterItem => {
		if (filterItem.id in newFilters) return

		if (
			filterItem.type === FilterType.AND ||
			filterItem.type === FilterType.OR
		) {
			newFilters[filterItem.id] = {
				id: filterItem.id,
				type: filterItem.type,
				optionIDs: []
			}
		}

		if (
			filterItem.type === FilterType.PRICE_RANGE ||
			filterItem.type === FilterType.RANGE
		) {
			const min = filterItem.rangeParams.rangeMin
			const max =
				filterItem.rangeParams.rangeMax +
				(filterItem.rangeParams.isMaxPlus ? 1 : 0)

			newFilters[filterItem.id] = {
				id: filterItem.id,
				type: filterItem.type,
				rangeLower: min,
				rangeUpper: max,
				defaultMin: min,
				defaultMax: max
			}
		}
	})

	return newFilters
}
